// Return 1 if v1 > v2
// Return -1 if v1 < v2
// Return 0 if v1 == v2
function compareVersions(version1, version2) {
    if (version1 === version2) {
      return 0;
    }
    let v1Array = version1.split(".");
    let v2Array = version2.split(".");
    let len = Math.min(v1Array.length, v2Array.length);
    for (let i = 0; i < len; i++) {
      if (parseInt(v1Array[i]) > parseInt(v2Array[i])) {
        return 1;
      }
      if (parseInt(v1Array[i]) < parseInt(v2Array[i])) {
        return -1;
      }
    }
    if (v1Array.length > v2Array.length) {
      return 1;
    }
    if (v1Array.length < v2Array.length) {
      return -1;
    }
    return 0; //both are same
  }
  
  module.exports = compareVersions;